import { Info } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function LotSizingFillRateNoProductSelected() {
  const { t } = useTranslation('lotSizing');

  return (
    <div className='flex flex-1 flex-col items-center justify-center gap-3 rounded-lg border border-blue-400 bg-blue-50 px-4 py-4 text-center dark:border-blue-700 dark:bg-blue-950/50'>
      <Info className='size-12 shrink-0 text-blue-600 dark:text-blue-400' />
      <div className='flex flex-col gap-1 text-blue-600 text-sm dark:text-blue-400'>
        <p>{t('noProductSelectedMessage')}</p>
      </div>
    </div>
  );
}
